import React, { useEffect, useMemo } from 'react';
import { i18nService } from '../../services/i18n.service';
import { I18nProps } from './I18n.interface';

function I18n(props: I18nProps) {
  const { style, className, element, title, elementProps, children, onCloseCallback, ...rest } =
    props;
  const text = useMemo(() => {
    // If children is not a string, transparently render the children as usual.
    return typeof children === 'string' ? i18nService.translate(children, rest) : children;
  }, [children, rest]);

  const titleDisplay = i18nService.translate(title || children, rest);
  // const titleDisplay = useMemo(() => i18nService.translate(title), [title]);
  useEffect(() => {
    return () => {
      onCloseCallback && onCloseCallback();
    };
  }, []);

  return React.createElement(
    element || 'span',
    { className, style, title: titleDisplay, ...elementProps },
    text,
  );
}

export default I18n;
